export interface LocalParts {
    date: string;
    time: string;
}

const pad = (value: number): string => String(value).padStart(2, "0");

const zonedParts = (instant: Date, timeZone: string): Record<string, number> => {
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
    const parts: Record<string, number> = {};
    for (const part of formatter.formatToParts(instant)) {
        if (part.type !== "literal") {
            parts[part.type] = Number(part.value);
        }
    }
    return parts;
};

const zoneOffsetMs = (instant: Date, timeZone: string): number => {
    const parts = zonedParts(instant, timeZone);
    const asUtc = Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour % 24,
        parts.minute,
        parts.second,
    );
    return asUtc - instant.getTime();
};

export const instantToLocalParts = (startsAt: string, timeZone: string): LocalParts => {
    const parts = zonedParts(new Date(startsAt), timeZone);
    return {
        date: `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`,
        time: `${pad(parts.hour % 24)}:${pad(parts.minute)}`,
    };
};

export const localPartsToInstant = (
    date: string,
    time: string,
    timeZone: string,
): Date => {
    const wallClock = new Date(`${date}T${time || "00:00"}:00Z`);
    const firstGuess = new Date(wallClock.getTime() - zoneOffsetMs(wallClock, timeZone));
    return new Date(wallClock.getTime() - zoneOffsetMs(firstGuess, timeZone));
};
